import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Dot,
  DotsWrapper,
  PulseCircle,
  SpinnerCircle,
  SpinnerLabel,
  SpinnerWrapper,
} from './Spinner.styled';

export type SpinnerVariant = 'default' | 'dots' | 'pulse';

export type SpinnerProps = {
  global?: boolean;
  showLabel?: boolean;
  containerHeight?: string;
  variant?: SpinnerVariant;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export const Spinner: FC<SpinnerProps> = ({
  global = false,
  showLabel = false,
  containerHeight,
  variant = 'default',
  size = 'md',
  label,
}) => {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('common.loading');
  const renderSpinner = () => {
    switch (variant) {
      case 'dots':
        return (
          <DotsWrapper $size={size}>
            <Dot $size={size} $delay={-0.32} />
            <Dot $size={size} $delay={-0.16} />
            <Dot $size={size} $delay={0} />
          </DotsWrapper>
        );
      case 'pulse':
        return <PulseCircle $size={size} />;
      case 'default':
      default:
        return <SpinnerCircle $size={size} $variant={variant} />;
    }
  };

  return (
    <SpinnerWrapper
      data-testid="spinner"
      $global={global}
      $containerHeight={containerHeight}
    >
      {renderSpinner()}
      {showLabel && <SpinnerLabel>{resolvedLabel}</SpinnerLabel>}
    </SpinnerWrapper>
  );
};
